import * as React from "react";
import { LoggedInUserProps } from "./types";
import HeaderLink from "../../layout/page/header/link-header";

import "./styles.scss";

const classNameBase = "scd-logged-in";

export default function LoggedInUser(
  props: LoggedInUserProps,
): React.JSX.Element {
  const { loginText, logoutText, onLoginClick, onLogoutClick, username } =
    props;

  const isLoggedIn = !!username;
  return (
    <div className={classNameBase}>
      {isLoggedIn ? (
        <div className={`${classNameBase}-user-wrapper`}>
          <HeaderLink
            title={username}
            className={`${classNameBase}-user disabled`}
            icon="icon-scd-user"
          >
            {username}
          </HeaderLink>
          <div className={`${classNameBase}-user`}>
            <HeaderLink
              title={logoutText}
              onClick={onLogoutClick}
              icon="icon-scd-logout"
            >
              {logoutText}
            </HeaderLink>
          </div>
        </div>
      ) : (
        <HeaderLink
          title={loginText}
          onClick={onLoginClick}
          icon="icon-scd-user"
        >
          {loginText}
        </HeaderLink>
      )}
    </div>
  );
}
